import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";

const CategoriesPage = () => {
  const { categories } = useApp();

  return (
    <div className="min-h-screen py-8" data-testid="categories-page">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="mb-8">
          <p className="bazaar-badge text-primary mb-2">Browse</p>
          <h1 className="text-3xl md:text-4xl font-bold">All Categories</h1>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category, index) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className={`category-card h-64 block animate-fade-in-up stagger-${(index % 6) + 1}`}
              data-testid={`category-${category.slug}`}
            >
              <img
                src={category.image_url || "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=500"}
                alt={category.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500"
              />
              <div className="absolute inset-0 z-10 flex flex-col justify-end p-6">
                <h3 className="text-2xl font-bold text-white mb-2">{category.name}</h3>
                {category.description && (
                  <p className="text-white/80 text-sm mb-3 line-clamp-2">{category.description}</p>
                )}
                <div className="flex items-center gap-2 text-white/90">
                  <span className="text-sm font-medium">Shop Now</span>
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        {categories.length === 0 && (
          <div className="text-center py-20">
            <p className="text-muted-foreground mb-4">No categories found</p>
            <Link to="/">
              <Button>Go to Home</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoriesPage;
